/// <reference types="@types/googlemaps" />
// import { } from '@types/googlemaps';

export class Feature {
    id: any;
    geometry: string;
    attributes: Object;

    constructor(options) {
      this.id = options.id;
      this.geometry = options.geometry;
      this.attributes = options.attributes;
    }

    getAttribute(attributeName: string): any {
      return this.attributes[attributeName];
    }

    getId(): number {
      return this.id;
    }

    toJSON(): string {
      return null;
    }

    static fromJSON(json: string): Feature {
      let feature = Object.create(Feature.prototype);
      return feature;
    }
}